import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyCoreService } from './company-core.service';

import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { CompanySelectorComponent } from './company-select/company-selector.component';
// import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [CompanySelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [CompanyCoreService],
  exports: [CompanySelectorComponent],
})
export class CompanyCoreModule {}
